
import { WithStyles, withStyles } from "@material-ui/core/styles";
import * as React from "react";
import Component from "src/shared/components/Component";
import Page from "src/shared/components/Page";
import withAxios, { IAxiosProps } from "src/shared/components/withAxios";
import TextField from '@material-ui/core/TextField';
import { ISubscriptionPurchasePageProps } from "./../IAdminPageProps";
import LoadingSpinner from 'src/shared/components/LoadingSpinner';
import "src/features/home/pages/signUp-pages/style.css";
import { FormControl, InputLabel, MenuItem, Select, Checkbox, List, ListItem, ListItemText, ListItemIcon, Button } from "@material-ui/core";
const planCheckList = [
  'Unlimited storage and surveys for up to 5 coaches',
  'Printable custom reports',
  'Preloaded questions',
  'AI generated analysis',
  'Unlimited storage and surveys for up to 20 coaches',
  'Preloaded and customizable questions',
  'Unlimited storage and surveys for up to 45 coaches',
  'Unlimited storage and surveys for all of your coaches',
  'Athletic Director survey',
  'Strength and conditioning surveys',
  'Parent surveys'
]
const styles = () => ({
  childTemplate: {
    paddingLeft: 80,
  },
  listItem: {
    "&:hover": {
      backgroundColor: "#e6e6e6",
    },
    backgroundColor: "white",
  },
});

type IProps = ISubscriptionPurchasePageProps &
  IAxiosProps &
  WithStyles<keyof ReturnType<typeof styles>>;

interface ITemplatesPageState {
  title: string;
  description: string;
  loader: boolean;
  price: string;
  payment_frequency_type: any;
  status: boolean,
  stripe_product_id: any,
  coachs: string,
  checkedItems: any
}

export default withStyles(styles)(
  withAxios(
    class UpdateSubscription extends Component<IProps, ITemplatesPageState> {
      public readonly state = this.buildState({
        title: "",
        description: '',
        loader: false,
        price: '',
        payment_frequency_type: '',
        status: true,
        stripe_product_id: null,
        coachs: "",
        checkedItems: [],
      });

      public componentDidMount(): void {

   if(Object.keys(this.props?.planSelect).length>0){
    this.setState({
      title: this.props?.planSelect?.title || "",
      description: this.props?.planSelect?.description || "",
      price: this.props?.planSelect?.price?.toString() || "",
      payment_frequency_type: this.props?.planSelect?.payment_frequency_type || "",
      status: this.props?.planSelect?.status === 'active' ? true : false,
      stripe_product_id: this.props?.planSelect?.stripe_product_id || "",
      coachs: this.props?.planSelect?.coachs || "",
      checkedItems: this.props?.planSelect?.select==null?[]:JSON?.parse(this.props?.planSelect?.select || [])||[],
    })
   }
      

      }
      // Handle toggling of checklist items
      public handleToggle = (value: any) => () => {
        const { checkedItems } = this.state;
        const currentIndex = checkedItems.indexOf(value);
        const newChecked = [...checkedItems];

        if (currentIndex === -1) {
          newChecked.push(value);
        } else {
          newChecked.splice(currentIndex, 1);
        }

        this.setState({ checkedItems: newChecked });
      };

      public async updatePlanHandler() {
        this.setState({ loader: true })
        const res: any = await this.buildPut(
          this,
          `payment/updatePlan/${this.props?.planSelect?.id}`
        )({
          title: this.state.title,
          description: this.state.description,
          price: this.state.price,
          payment_frequency_type: this.state.payment_frequency_type,
          status: this.state.status === true ? 'active' : 'inactive',
          stripe_product_id: this.state.stripe_product_id,
          coachs: this.state?.coachs || "",
          select: JSON?.stringify(this.state.checkedItems || [])||[],
        });
        this.setState({ loader: false })
        console.log("res====================?", res)
      }
      public render() {

        const { checkedItems } = this.state;
        return (
          <>
            {this.state.loader &&<div className="loader-bg-color">
              <LoadingSpinner /></div>}
            <Page header="Subscription">
              <div>
                <div style={{ marginTop: 20 }}>
                  <Button variant="contained" color="primary" onClick={()=>{
                    this.updatePlanHandler()
                  }}>
                    Submit
                  </Button>
                </div>
                <div className="title-coach">
                <div className="title" style={{ marginTop: 10 }}>
                  <TextField
                    label="Title"
                    variant="outlined" // You can change this to "filled" or "standard"
                    fullWidth={true} // This will make the input take the full width of the container
                    onChange={(e) => this.setState({ title: e.target.value })} // Handle the change event
                    value={this.state.title}
                  />
                </div>
               
                <div className="coach" style={{ marginTop: 10 }}>
                  <TextField
                    label="Coaches"
                    variant="outlined" // You can change this to "filled" or "standard"
                    fullWidth={true} // This will make the input take the full width of the container
                    onChange={(e) => this.setState({ coachs: e.target.value })} // Handle the change event
                    value={this.state.coachs}
                  />
                </div>
                </div>
                <div className="price-select">
                <div className="price" style={{ marginTop: 20 }}>
                  <TextField
                    label="Price"
                    variant="outlined" // You can change this to "filled" or "standard"
                    fullWidth={true} // This will make the input take the full width of the container
                    onChange={(e) => this.setState({ price: e.target.value })} // Handle the change event
                    value={this.state.price}
                  />
                </div>
                <div className="select" style={{ marginTop: 20 }}>
                  <FormControl variant="outlined" fullWidth={true}>
                    <InputLabel id="dropdown-label">Choose an option</InputLabel>
                    <Select
                      labelId="dropdown-label"
                      value={this.state.payment_frequency_type}
                      onChange={(event) => {
                        this.setState({ payment_frequency_type: event.target.value })
                      }}
                      label="Select Payment Frequently"
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      <MenuItem value={'free'}>Free</MenuItem>
                      <MenuItem value={'monthly'}>Monthly</MenuItem>
                      <MenuItem value={'yearly'}>Yearly</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                </div>
                <div style={{ marginTop: 20 }}>
                  <TextField
                    label="Description"
                    variant="outlined" // You can change this to "filled" or "standard"
                    fullWidth={true} // This will make the input take the full width of the container
                    onChange={(e) => this.setState({ description: e.target.value })} // Handle the change event
                    value={this.state.description}
                    multiline={true}
                    rows={4}
                  />
                </div>
                <div style={{ marginTop: 10 }}>

                  <List>
                    <InputLabel >What's Include in</InputLabel>
                    {planCheckList.map((item, index) => (
                      <ListItem key={index} button={true} onClick={this.handleToggle(item)}>
                        <ListItemIcon>
                          <Checkbox
                            edge="start"
                            checked={checkedItems.indexOf(item) !== -1}
                            tabIndex={-1}
                            disableRipple={true}
                          />
                        </ListItemIcon>
                        <ListItemText primary={item} />
                      </ListItem>
                    ))}
                  </List>
                </div>

                <div style={{ marginTop: 20 }}>
                  <Button variant="contained" color="primary" onClick={()=>{
                    this.updatePlanHandler()
                  }}>
                    Submit
                  </Button>
                </div>
              </div>
            </Page>
            
          </>
        );
      }



    }
  )
);



// WEBPACK FOOTER //
// ./src/features/admin/pages/SubscriptionPurchaseList/updateSubscription.tsx